module.exports = __webpack_public_path__ + "img/goal_pc.d7fc5d69.jpg";